import { Inject, Injectable } from '@angular/core';
import { Resource } from '@app/shared/resources/resource';
import { HttpClient } from '@angular/common/http';
import { Environment, environmentToken } from '@environment';
import { Observable } from 'rxjs';
import { LuminaireDriver } from '@app/shared/models/luminaire-driver';
import { SensorNodeIdsBatch } from '@app/shared/models/sensor-node-batch.interface';

@Injectable({
  providedIn: 'root'
})
export class LuminaireDriverResource extends Resource<LuminaireDriver, number> {
  constructor(private http: HttpClient, @Inject(environmentToken) private environment: Environment) {
    super(http, `${environment.apiUrl}${environment.apiPath}/luminaire-driver`);
  }

  public getByNodeIds(nodeIds: number[]): Observable<LuminaireDriver[]> {
    return this.http.post<LuminaireDriver[]>(`${this.baseUrl}/node`, new SensorNodeIdsBatch(nodeIds));
  }

  public getByNodeId(nodeId: number): Observable<LuminaireDriver[]> {
    return this.http.get<LuminaireDriver[]>(`${this.baseUrl}/node/${nodeId}`);
  }

  public getByFloorId(floorId: number): Observable<LuminaireDriver[]> {
    return this.http.get<LuminaireDriver[]>(`${this.baseUrl}/floor/${floorId}`);
  }
}
